export default __webpack_public_path__ + "static/media/astro-scene_1.1059c159.png";